import React from 'react';

import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import CloudOffIcon from '@material-ui/icons/CloudOff';

function Disconnected() {
  return (
    <Alert
      className="margin-top-20"
      icon={<CloudOffIcon color="secondary" fontSize="inherit" />}
      severity="info"
      style={{ textAlign: 'left' }}
    >
      <AlertTitle>No Connection</AlertTitle>
      Connect to the Internet to continue
    </Alert>
  );
}

export default Disconnected;
